

















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NavBar from '../../components/NavBar.vue';
import TabBar from '../../components/TabBar.vue';
import Button from '../../components/Button.vue';
import Booking from '@/types/taxcard/Booking';
import { Action, Getter, namespace } from 'vuex-class';
import Loader from '@/components/Loader.vue';
import BIObject from '@/types/taxcard/BIObject';
import BookingPriceProjection from '@/types/projections/BookingPriceProjection';
import CheckboxField from '@/components/form/CheckboxField.vue';
import moment, { Moment } from 'moment';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';
import PriceDiscountOptionProjection from '@/types/projections/PriceDiscountOptionProjection';
import { NamedRoutes } from '@/routes/routes';
import AuthRedirect from '@/app/utils/AuthRedirect';
import CheckoutApi from '@/app/api/CheckoutApi';
import MobilePaymentApi from '@/app/utils/MobilePaymentApi';
import { CheckoutRoutes } from '@/app/api-routes';
import { GuestTypesEnum } from '@/types/taxcard/GuestType';
const CheckoutModule = namespace('checkout');
const BookingModule = namespace('booking');
const I18nModule = namespace('i18n');
@Component({
  components: {
    NewTranslation,
    NavBar,
    TabBar,
    Button,
    Loader,
    CheckboxField,
  },
})
export default class CheckoutView extends Vue {
  @Prop(Object)
  private pagedata!: any;

  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  private paymentIsLoading: boolean = false;

  @BookingModule.Getter
  public currentBooking!: Booking | null;

  @BookingModule.Getter
  public currentPriceProjection!: BookingPriceProjection | null;

  @BookingModule.Getter
  public currentOrderId!: string | null;

  @BookingModule.Mutation
  private setCurrentBooking!: any;

  @BookingModule.Mutation
  private setCurrentPriceProjection!: any;

  @BookingModule.Mutation
  private setCurrentOrderId!: any;

  @BookingModule.Mutation
  public setCurrentPaymentMethod!: any;

  @Action
  public saveRegistrationForm!: any;

  public paymentMethodsLoading: boolean = false;

  public booking: Booking | null = null;

  public paymentMethods!: string[];

  public isPayOnePaymentMethod: boolean = false;

  @Getter
  public loggedInUser!: boolean;

  @Getter
  public communeInfo!: any;

  public paymentMethod: string | null = null;

  public tacAccepted: boolean = false;

  public adultPermissionGranted: boolean = false;

  public communeMailConsent: boolean = false;

  public paymentIsPreparing: boolean = false;

  public discountLoaders: { [k: number]: any } = {};

  public ticketDiscounts: { [k: number]: PriceDiscountOptionProjection | null } = {};

  @BookingModule.Action('fetchCommuneDiscounts')
  public fetchCommuneDiscounts!: any;

  @I18nModule.Getter
  private readonly locale!: string;

  private async created() {
    const redirectRoute = AuthRedirect.getRedirect();
    if (redirectRoute.name === 'checkout') {
      AuthRedirect.resetRedirectData();
    }
    if (!this.currentBooking) {
      console.error('No current booking found!');
      return;
    }

    this.$trackEvent('checkout', 'entered');

    this.paymentMethodsLoading = true;

    try {
      this.paymentMethods = await CheckoutApi.getPaymentMethods(this.currentBooking.communeId);
      if (this.paymentMethods.length == 1 && this.paymentMethods[0] == 'PAYONE') {
        this.paymentMethod = this.paymentMethods[0];
        this.isPayOnePaymentMethod = true;
      }
    } catch (e) {
      console.error('Failed to fetch payment methods');
    } finally {
      this.paymentMethodsLoading = false;
    }
    this.currentBooking.bIObjects.forEach((bIObject, index) => {
      if (!bIObject.bIObjectData.option) {
        return;
      }
      this.discountLoaders[index] = true;
      // @ts-ignore
      this.fetchCommuneDiscounts({ communeId: this.currentBooking.communeId, bIObject: bIObject })
        .then((discounts: PriceDiscountOptionProjection[]) => {
          const ticketDiscountOptionId = Object.keys(bIObject.bIObjectData.option)[0];
          if (!ticketDiscountOptionId) {
            this.ticketDiscounts[index] = null;
            return;
          }
          const discount = discounts.find(d => d.id === parseInt(ticketDiscountOptionId, 10));
          if (!discount) {
            this.ticketDiscounts[index] = null;
            return;
          }
          this.ticketDiscounts[index] = discount;
        })
        .catch((e: any) => {
          console.error('Failed to fetch commune discounts', e);
          this.ticketDiscounts[index] = null;
        })
        .finally(() => {
          this.discountLoaders[index] = false;
          this.$forceUpdate();
        });
    });
    if (this.$route.query.error) this.errorOverlay();
    const wrapperElement = document.querySelector('.navbar');
    if (wrapperElement) wrapperElement.scrollIntoView();
  }

  @Watch('paymentMethod')
  private onPaymentMethodSelected(paymentMethod: string | null) {
    this.$trackEvent('checkout', 'payment-method', 'selected', paymentMethod);
  }

  public goToLogin(): void {
    this.$trackEvent('checkout', 'login');
    AuthRedirect.setRedirect({ name: NamedRoutes.checkout });
    this.$router.push({ name: 'login' });
  }

  public translate(path: string, params?: any): string {
    return i18next.t(path, params);
  }

  public formatPrice(price?: number): string {
    if (!price) {
      price = 0;
    }
    return `${price.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} €`;
  }

  public taxcardPrice(index: number, key: string): string {
    if (!this.currentPriceProjection) {
      console.error('No current priceProjection found!');
      return '';
    }
    const prices: any = this.currentPriceProjection;
    return this.formatPrice(prices.taxcards[index][key]);
  }

  public personCountString(bIObject: BIObject): string {
    const hasDayGroupBooking = !!(this.communeInfo && this.communeInfo.dayGuestGroupBooking);
    if ((bIObject.bIObjectData.guestType === GuestTypesEnum.overnight || (bIObject.bIObjectData.guestType === GuestTypesEnum.day && hasDayGroupBooking)) && bIObject.bIObjectData.personCount > 0) {
      return `+ ${bIObject.bIObjectData.personCount} ${this.translate('checkout.group.participants.label')}`;
    }
    return '';
  }

  public get anyAnonymBookings(): boolean {
    const booking = this.currentBooking;
    if (!booking) {
      return false;
    }
    return booking.bIObjects.some((t: BIObject) => t.bIObjectData.isAnonymous);
  }

  public get anyTaxcardEmailsGiven(): boolean {
    const booking = this.currentBooking;
    if (!booking) {
      return false;
    }
    return booking.bIObjects.some((t: BIObject) => !!t.bIObjectData.email);
  }

  public get anyNonAdultBookings(): boolean {
    const booking = this.currentBooking;
    if (!booking) {
      return false;
    }
    return booking.bIObjects
      .filter(t => t.bIObjectData.birthday !== null && t.bIObjectData.birthday.isValid())
      .map(t => moment.utc().diff(moment.utc(t.bIObjectData.birthday as Moment), 'year') as number)
      .some(age => age <= 14);
  }

  public get totalPets(): number {
    const booking = this.currentBooking;
    if (!booking) {
      return 0;
    }
    return booking.bIObjects.reduce((acc: number, ticket: BIObject) => acc + ticket.bIObjectData.petCount, 0);
  }

  public get isBookingReadyToBePaid(): boolean {
    return Boolean(
      this.communeInfo.name !== 'Keine Kommune selektiert' &&
        this.currentPriceProjection &&
        (this.currentPriceProjection.price === 0 || this.paymentMethod) &&
        (!this.anyNonAdultBookings || this.adultPermissionGranted)
    );
  }

  public async proceedToPayment(): Promise<void> {
    if (!this.isBookingReadyToBePaid) {
      return;
    }
    this.$trackEvent('checkout', 'payment-proceed');

    await CheckoutApi.saveCommuneMailConsent(this.currentOrderId, this.communeMailConsent)

    this.paymentIsLoading = true;
    // if price is 0, we can trigger the free checkout prozess
    if (this.currentPriceProjection !== null && this.currentPriceProjection.price === 0) {
      this.$trackGoal(1, 0);
      const result = await CheckoutApi.freeCheckout(this.currentOrderId);
      if (result.finalized) {
        if (this.currentBookingIsRegistrationFormCandidate()) { //Changes for registration for just foreigners
          await this.sendEmptyRegistrationForm();
        } //Changes for registration for just foreigners
        this.successOverlay();
        return;
      }
    }

    // check if embeded payment is enabled
    if (this.communeInfo.embededPaymentEnabled) {
      this.setCurrentPaymentMethod(this.paymentMethod);

      this.$router.push({
        name: NamedRoutes.checkoutPayment,
      });
      return;
    }

    // check if mobile channel API is present
    if (MobilePaymentApi.hasMobilePaymentApi()) {
      MobilePaymentApi.startPayment(this.currentOrderId, this.paymentMethod);
    } else {
      if (!this.currentOrderId || !this.paymentMethod) {
        return;
      }
      await this.goToCheckoutPage(this.currentOrderId, this.paymentMethod);
    }
  }

  async sendEmptyRegistrationForm() {
    try {
      await this.saveRegistrationForm({
        signature: null,
        passportNumber: '',
        orderId: this.currentOrderId,
      });
    } catch (e) {
      console.log('Could not save registration form!');
    }
  }

  public async goToCheckoutPage(orderId: string, paymentMethod: string) {
    if (paymentMethod == 'PAYONE') {
      let payOneUrl = "";
      try {
        payOneUrl = await CheckoutApi.getPaymentEntryPage(orderId, paymentMethod, this.locale)
      } catch (e) {
        console.log("Could not StartPayment");
        payOneUrl = '';
      }
      if (payOneUrl =='') {
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: i18next.t('checkout.errors.failed.title'),
            message: i18next.t('checkout.errors.declined.message'),
          },
        });
      } else {
        window.location.href = payOneUrl;
      }
    } else {
      window.location.href = CheckoutRoutes.startPayment(orderId, paymentMethod, this.locale);
    }
  }

  private resetBookingData(): void {
    this.setCurrentBooking(null);
    this.setCurrentPriceProjection(null);
    this.setCurrentOrderId(null);
  }

  private successOverlay(): void {
    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        submit: () => {
          if (!this.currentBookingIsRegistrationFormCandidate()) {
            this.$router.push({ name: 'transactionOverview', params: { purchaseSuccess: 'true' } });
            this.resetBookingData();
            this.paymentIsPreparing = false;
            window.history.pushState({}, document.title, '/');
            return;
          }

          this.paymentIsPreparing = false;
          this.$router.push({ name: 'bookingRegistrationForm' });
        },
        title: i18next.t('checkout.confirmDialog.title'),
        message: i18next.t('checkout.confirmDialog.body'),
      },
    });
  }

  private errorOverlay() {
    if (this.$route.query.error !== 'payment-failed-redirect') return;

    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: {
        title: i18next.t('checkout.errors.failed.title'),
        message: i18next.t('checkout.errors.failed.message'),
      },
    });
  }

  private currentBookingIsRegistrationFormCandidate(): boolean {
    const booking = this.currentBooking;
    if (!booking) {
      return false;
    }

    //Registration for all
    // return booking.bIObjects.some(t => t.guestType === GuestTypesEnum.overnight && !t.isAnnual);

    //Registration just for foreigners
    return booking.bIObjects.some(t => t.bIObjectData.guestType === GuestTypesEnum.overnight && !t.bIObjectData.isAnnual && t.bIObjectData.nationality !== 'DE');
  }

  public moment(...args: any[]): any {
    return moment(...args);
  }

  public formatDate(date: string): string {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format(i18next.t('common.date.format.short')) : 'Ungültiges Datum';
  }
}
